<div class="modal-body">
  <div>
    <form
      #formregistro="ngForm"
      name="formregistro"
      class="smart-form"
      novalidate>
      <fieldset>
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <h4>Datos Personales</h4>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label class="label">Nombre Completo</label>
              <input
                class="form-control"
                [disabled]="true"
                name="namePerson"
                type="text"
                placeholder="{{ registerPerson.namePerson }}" />
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label class="label">País</label>
              <select2
                *ngIf="registerPerson.countryIso; else countryTemplate"
                name="countries"
                [data]="countriesDto"
                [value]="registerPerson.countryIso"
                [disabled]="true">
              </select2>
              <ng-template #countryTemplate>
                <input
                  class="form-control"
                  [disabled]="true"
                  placeholder="{{ registerPerson.country }}"
              /></ng-template>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label class="label">Tipo de Identificación</label>
              <input
                class="form-control"
                [disabled]="true"
                name="identificationType"
                type="text"
                placeholder="{{ registerPerson.identificationType }}" />
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label class="label">DNI</label>
              <div class="input-group">
                <div class="input-group-btn">
                  <input
                    class="form-control"
                    [disabled]="true"
                    type="text"
                    placeholder="{{ registerPerson.dniPerson }}" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label class="label">Tipo de Persona</label>
              <input
                class="form-control"
                [disabled]="true"
                placeholder="{{ registerPerson.personType }}" />
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label class="label">Estado</label>
              <input
                class="form-control"
                [disabled]="true"
                placeholder="{{ registerPerson.nameStatus }}" />
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
  <ml-unlock-temporarily-panel
    *ngIf="showButton"
    [person]="registerPerson"
    (sendUnlockData)="reloadComponent($event)">
  </ml-unlock-temporarily-panel>
  <div style="padding: 1%" *ngIf="mostrarBtnHistorial">
    <button
      authorizedElement
      [authElementCode]="19503"
      [authElementName]="'BTN_MARK_LIST_CHANGE_STATUS'"
      class="btn btn-info"
      (click)="toggleHistorySinester()">
      {{ mostrarHistorialSiniestros ? 'Ocultar' : 'Mostrar' }}
      Historial Siniestros
    </button>
    <!-- este es el boton de administrar estados, esto me falta checkearlo -->
    <button
      authorizedElement
      [authElementCode]="19503"
      [authElementName]="'BTN_MARK_LIST_CHANGE_STATUS'"
      class="btn btn-info btn-sm pull-right"
      (click)="changesStatesButton()">
      {{
        !registrobool
          ? ('BTN_LABEL_MANAGE_STATES' | i18n)
          : ('BTN_LABEL_NO_CANCELAR' | i18n)
      }}
    </button>
  </div>

  <div class="row" *ngIf="mostrarHistorialSiniestros">
    <div class="col-md-12">
      <h4>Siniestros</h4>
      <div class="table-responsive text-center">
        <app-ml-table-sinester
          [sinesterData]="sinesterData"></app-ml-table-sinester>
      </div>
    </div>
  </div>

  <app-ml-status-person
    [statusData]="statusData"
    [personData]="registerPerson"
    [editMode]="registrobool"
    (refresh)="refresh()">
  </app-ml-status-person>
</div>
